<div class="roi-popup-overlay" [class.active]="roiPopupVisible">
    <div class="roi-popup">
        <button class="roi-popup-close" (click)="closeROIPopup()">&times;</button>
        
        <div [class.active]="currentStep === 1" id="roiStep1" class="roi-step active">
            <div class="roi-header">
                <div class="roi-icon">📊</div>
                <h2>Revenus générés la première année</h2>
                <p>Découvrez combien vous pourriez générer avec Wealthlane</p>
            </div>
            
            <div class="roi-input-group">
                <label for="clientCount">Combien de clients avez-vous dans votre portefeuille ?</label>
                <input type="number" id="clientCount" min="1" max="10000" value="100" placeholder="Ex: 100"  [(ngModel)]="clientCount">
                <span class="roi-input-hint">Nombre total de clients</span>
            </div>
            
            <div class="roi-input-group">
                <label for="pmePercentage">Combien sont des dirigeants de PME/ETI ?</label>
                <div class="roi-slider-container">
                    <input type="range" id="pmePercentage" min="0" max="100" value="50" class="roi-slider" [(ngModel)]="pmePercentage">
                    <div class="roi-slider-value" [style]="'left:' +pmePercentage+'%'">
                        <span id="pmePercentageValue">{{pmePercentage}}%</span>
                    </div>
                </div>
                <div class="roi-slider-labels">
                    <span>0%</span>
                    <span>50%</span>
                    <span>100%</span>
                </div>
            </div>
            
            <button class="btn-roi-calculate" (click)="calculateROI()">
                <span>Calculer</span>
               <img src="/images/landing/calcul.svg" alt="arrow-right" class="arrow-right">
            </button>
        </div>
        
        <div [class.active]="currentStep === 2" id="roiStep2" class="roi-step">
            <div class="roi-header">
                <div class="roi-icon success">🎉</div>
                <h2>Vos revenus générés estimés</h2>
                <p>Voici ce que Wealthlane peut vous rapporter</p>
            </div>
            
            <div class="roi-result">
                <div class="roi-highlight-box">
                    <div class="roi-result-label">💰 Revenus additionnels potentiels</div>
                    <div class="roi-result-range">
                        <span class="roi-result-min" id="roiMin">{{roiMin}}€</span>
                        <span class="roi-result-separator">à</span>
                        <span class="roi-result-max" id="roiMax">{{roiMax}}€</span>
                    </div>
                    <div class="roi-result-period">par an</div>
                    <div class="roi-highlight-text">
                        ✅ Vous êtes déjà leur référence, ils vous font confiance.<br>
                        Pourquoi laisser ces missions — et ces revenus — à d'autres ?
                    </div>
                </div>
                
                <div class="roi-details">
                    <div class="roi-detail-item highlight">
                        <div class="roi-detail-label">🎯 Clients PME/ETI</div>
                        <div class="roi-detail-subtitle">Dans votre portefeuille</div>
                        <span class="roi-detail-value" id="pmeCount">{{pmeCount}}</span>
                    </div>
                    <div class="roi-detail-item highlight">
                        <div class="roi-detail-label">⚡ Missions</div>
                        <div class="roi-detail-subtitle">Potentiel annuel</div>
                        <span class="roi-detail-value" id="missionCount">{{missionCount}}</span>
                    </div>
                    <div class="roi-detail-item">
                        <div class="roi-detail-label">💎 Valeur mission</div>
                        <div class="roi-detail-subtitle">Selon complexité</div>
                        <span class="roi-detail-value">2-8K€</span>
                    </div>
                    <div class="roi-detail-item">
                        <div class="roi-detail-label">💰 Commission</div>
                        <div class="roi-detail-subtitle">Ponctuelle</div>
                        <span class="roi-detail-value">{{commission}}%</span>
                    </div>
                </div>

                <div class="roi-success-message">
                    <div class="success-icon">💡</div>
                    <div class="success-text">
                        <strong>En plus du bilan que vous vendez</strong>, générez 1% de commission sur chaque produit souscrit (assurance-vie, SCPI, etc.) via notre plateforme.
                    </div>
                </div>
            </div>
            
            <div class="roi-cta">
                <button class="btn-roi-demo" (click)="closeROIPopup(); openDemoPopup()">
                    <span>Demander ma démo personnalisée</span>
                    <img src="/images/landing/calcul.svg" alt="arrow-right" class="arrow-right">
                </button>
                <button class="btn-roi-recalculate" (click)="resetROICalculator()">
                    ↻ Recalculer avec d'autres données
                </button>
            </div>
        </div>
    </div>
</div>